var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icons",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 215 215",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#07f;}.cls-2{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "VK"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Background",
    className: "cls-1",
    d: "M0,103.2c0-48.65,0-73,15.11-88.09S54.55,0,103.2,0h8.6c48.65,0,73,0,88.09,15.11S215,54.55,215,103.2v8.6c0,48.65,0,73-15.11,88.09S160.45,215,111.8,215h-8.6c-48.65,0-73,0-88.09-15.11S0,160.45,0,111.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "VK-2",
    "data-name": "VK",
    className: "cls-2",
    d: "M112,151c-45.86,0-72-31.44-73.1-83.75h23c.75,38.4,17.69,54.66,31.1,58v-58h21.63v33.12c13.24-1.43,27.16-16.52,31.85-33.12h21.63c-3.6,20.46-18.69,35.55-29.42,41.75,10.73,5,27.91,18.19,34.45,42H149.29C144.18,135,131.44,122.7,114.59,121V151Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVk);
export default __webpack_public_path__ + "static/media/VK.ed8d6d60c06e0d9bd93372361a120c57.svg";
export { ForwardRef as ReactComponent };